// src/components/Header.js
import React from 'react';

const Header = () => {
  return (
    <header className="header-container">
      <div className="header-content">
        <img src='/white_logo.png' alt="Wedding Logo" className="header-logo" />
        <h1>Coleen & Thai</h1>
        <h2>Say I Do in Boston</h2>
        <p>10.19.2024</p>
      </div>
    </header>
  );
};

export default Header;
